module.exports = __webpack_public_path__ + "img/default_cover.d4cfa42d.jpg";